import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Flex, Button, Text, SimpleGrid, Alert, AlertIcon } from '@chakra-ui/react';
import InputSearch from '../../../shared/inputSearch/InputSearch';
import Pagination from '../../../shared/pagination/Pagination';
import Breadcrumbs from '../../../shared/breadcrumbs/Breadcrumbs';
import ServersTable from './ServersTable';
import CreateModal from './actions/CreateModal';
import UpdateModal from './actions/UpdateModal';
import DeleteModal from './actions/DeleteModal';
import { getServers, approveServer } from '../../../../store/servers/serversSlice';
import { RulesWrapper } from '../rules/RulesStyle';
import theme from '../../../global/theme';

const Servers = () => {
  const dispatch = useDispatch();
  const servers = useSelector(state => state.servers);

  const [page, setPage] = useState(1);
  const [query, setQuery] = useState('');
  const [filter] = useState(JSON.stringify({}));

  const [showCreate, setShowCreate] = useState(false);
  const [showUpdate, setShowUpdate] = useState(false);
  const [showDelete, setShowDelete] = useState(false);

  useEffect(() => {
    dispatch(getServers({ page, query, filter, sort: 'order -created_at' }));
  }, [dispatch, page, query, filter]);

  return (
    <RulesWrapper>
      <Breadcrumbs currentPage="السيرفرات" pages={[{ name: 'لوحة التحكم', path: '/admin' }]} />

      {servers.errors.length > 0 && (
        <Alert status="error" variant="left-accent" marginBottom={8}>
          <AlertIcon />
          {servers.errors.map((e, i) => <Text key={i}>{e?.msg}</Text>)}
        </Alert>
      )}

      <SimpleGrid columns={{ sm: 1, md: 2 }} justifyContent="space-between">
        <Flex marginBottom={8}>
          <Button bg="red.600" textTransform="uppercase" fontWeight="bold" fontSize={18}
            marginInlineEnd={4} color="white" _hover={{ bg: 'red.600' }}
            onClick={() => setShowCreate(true)}
          >
            إضافة سيرفر
          </Button>
        </Flex>
        <Flex marginBottom={8} justifyContent="flex-end">
          <InputSearch isLoading={servers.isLoading} handleSearch={(q) => setQuery(q)} />
        </Flex>
      </SimpleGrid>

      {servers.data?.itemsCount > 0 ? (
        <ServersTable
          data={servers.data.data}
          page={page}
          handleUpdate={(el) => setShowUpdate(el)}
          handleDelete={(el) => setShowDelete(el)}
          handleApprove={(el) => dispatch(approveServer({ _id: el._id }))}
        />
      ) : (
        <Flex textAlign="center" bg={theme.light} boxShadow={theme.shadow} height={200}
          alignItems="center" justifyContent="center" borderRadius={4}>
          <Text fontSize={18} textTransform="capitalize" color="gray.300" fontWeight="bold">
            لا توجد سيرفرات
          </Text>
        </Flex>
      )}

      <Flex justifyContent="flex-end">
        <Pagination
          page={page}
          itemsCount={servers.data?.itemsCount ?? 0}
          onChange={(p) => setPage(p)}
        />
      </Flex>

      {showCreate && <CreateModal onClose={() => setShowCreate(false)} />}
      {showUpdate && <UpdateModal data={showUpdate} onClose={() => setShowUpdate(false)} />}
      {showDelete && <DeleteModal data={showDelete} onClose={() => setShowDelete(false)} />}
    </RulesWrapper>
  );
};

export default Servers;
